module.exports = __webpack_public_path__ + "static/media/goodnest.a3a8cea0.jpg";